import { Controller } from '@hotwired/stimulus';

// This Stimulus controller manages a small part of the accordion functionality
// in the participant view. It ensures that the correct accordion item is open
// when the page is loaded with a specific hash in the URL.
// The bulk of the accordion functionality is handled by the native HTML
// <details> element, which provides built-in accessibility features.

export default class extends Controller {
  connect() {
    this.accordionItems = this.element.querySelectorAll('.accordion-item');
    this.currentAccordionItem = null;

    const locationHash = window.location.hash;
    if (locationHash) {
      this.currentAccordionItem = this.element.querySelector(locationHash);
      if (this.currentAccordionItem) {
        this.currentAccordionItem.setAttribute('open', true);
        this.currentAccordionItem.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
